"use client";

import { JSX, ReactNode, Suspense } from "react";
import ErrorBoundary from "rivals/components/app/ErrorBoundary";
import Spinner from "rivals/components/shared/Spinner";

export default function ErrorBoundaryWrapper({
  children,
  withSuspense = false
}: {
  children: ReactNode;
  withSuspense?: boolean;
}): JSX.Element {
  const content = withSuspense ? (
    <Suspense fallback={<Spinner />}>{children}</Suspense>
  ) : (
    children
  );
  return <ErrorBoundary fallback={null}>{content}</ErrorBoundary>;
}
